import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import { saveDoc } from '../gestorDocumental/actions';
import gestorDocumentalServices from '../gestorDocumental/gestorDocumental.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getRelatives = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_RELATIVES,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    const resp = await client.get(iType === 1 ? 'api/app/Formal_Dependientes_Economico/' : `/api/app/Funcional_Dependientes_Economico/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_RELATIVES,
      payload: {
        relatives: resp.data.data,
        relativesLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_RELATIVES,
      payload: false
    });
  }
}

export const saveRelatives = (data, iType, dataGD, exist, setShowModal, setValidFechaDoc, formReset) => async (dispatch, getState) => {
  try {
    debugger;
    dispatch({
      type: actions.SAVE_LOADER_RELATIVES,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Dependientes_Economico/' : '/api/app/Funcional_Dependientes_Economico/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    dataGD.append("id_registro", parseInt(resp.data.id));
    const { relatives, relativesLength } = getState().relatives;
    if(exist){
      const respGD = await gestorDocumentalServices.saveDocument(dataGD);
      const respPUTRel = await client.put(iType === 1 ? `/api/app/Formal_Dependientes_Economico/${resp.data.id}/` : `/api/app/Funcional_Dependientes_Economico/${resp.data.id}/`, {
        ...data,
        archivos_gestor: respGD.data.resultado.id
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }});
      const aRelatives = [...relatives, respPUTRel.data];
      dispatch({
        type: actions.GET_RELATIVES,
        payload: {
          relatives: aRelatives,
          relativesLength: relativesLength + 1
        }
      });
    }else{
      const aRelatives = [...relatives, resp.data];
      dispatch({
        type: actions.GET_RELATIVES,
        payload: {
          relatives: aRelatives,
          relativesLength: relativesLength + 1
        }
      });
    }

    toastr.success(messages.successMessage);
    formReset.reset();
    setShowModal(false);
    setValidFechaDoc(false);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_RELATIVES,
      payload: false
    });
  }
}

export const editRelatives = (data, id, index, iType, dataGD, arGD, exist, setShowModal, setValidFechaDoc) => async (dispatch, getState) => {
  try {
    debugger;
    dispatch({
      type: actions.SAVE_LOADER_RELATIVES,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const { relatives, relativesLength } = getState().relatives;
    if(exist){
      let respGD;
      if(arGD){
        respGD = await gestorDocumentalServices.editDocument(arGD, dataGD);
      }else{
        respGD = await gestorDocumentalServices.saveDocument(dataGD);
      }
      const resp = await client.put(iType === 1 ? `/api/app/Formal_Dependientes_Economico/${id}/` : `/api/app/Funcional_Dependientes_Economico/${id}/`, {
        ...data,
        archivos_gestor: arGD ? respGD.data.id : respGD.data.resultado.id
      }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
      relatives[index] = resp.data;
    }else{
      const resp = await client.put(iType === 1 ? `/api/app/Formal_Dependientes_Economico/${id}/` : `/api/app/Funcional_Dependientes_Economico/${id}/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
      relatives[index] = resp.data;
    }
    dispatch({
      type: actions.GET_RELATIVES,
      payload: {
        relatives: relatives,
        relativesLength: relativesLength
      }
    });
    toastr.success(messages.successMessage);
    setShowModal(false);
    setValidFechaDoc(false);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_RELATIVES,
      payload: false
    });
  }
}

export const deleteRelatives = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_RELATIVES,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Dependientes_Economico/${id}/` : `/api/app/Funcional_Dependientes_Economico/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { relatives, relativesLength } = getState().relatives;
    relatives.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_RELATIVES,
      payload: {
        relatives: relatives,
        relativesLength: relativesLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_RELATIVES,
      payload: false
    });
  }
}
